import { Button, Kind } from '@thanx/uikit/button'
import { Notification } from '@thanx/uikit/notification'
import { Text } from '@thanx/uikit/text'
import PopoverInfo from 'components/PopoverInfo'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import { TimeBasedMenuVisibilitySetting } from 'models/Config'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'

const t = buildTranslate('cms.settings.time_based_menu_visibility')

function getDisplayValue(
  setting: TimeBasedMenuVisibilitySetting | undefined
): string {
  if (setting === TimeBasedMenuVisibilitySetting.HIDDEN) {
    return t('options.hidden')
  }
  return t('options.visible')
}

type Props = {
  setting?: TimeBasedMenuVisibilitySetting
  isLoading: boolean
  isError: boolean
  showTitle: boolean
  onEdit: () => void
}

const TimeBasedMenuVisibilityView = ({
  setting,
  isLoading,
  isError,
  showTitle,
  onEdit,
}: Props) => (
  <CmsPage
    showTitle={showTitle}
    title={t('title')}
    description={t('description')}
    isLoading={isLoading}
  >
    {isError ? (
      <div data-testid="time-based-menu-visibility-fetch-error" role="alert">
        <Notification kind="negative" size="full">
          <Text.BodyText4 color="grey70" className="p-xs" tag="div">
            {t('fetch_error')}
          </Text.BodyText4>
        </Notification>
      </div>
    ) : (
      <Section className="p-m">
        <div className="d-flex align-items-center justify-content-between mb-m">
          <Text.Header4 className="my-0">{t('section_title')}</Text.Header4>
          <Button kind={Kind.MINIMAL} onClick={onEdit}>
            {t('edit')}
          </Button>
        </div>
        <div>
          <p className="bold font-size-14 mb-0">
            {t('field_label')}
            <PopoverInfo className="ml-xs" text={t('description')} />
          </p>
          <p className="grey-70 mt-xs">{getDisplayValue(setting)}</p>
        </div>
      </Section>
    )}
  </CmsPage>
)

export default TimeBasedMenuVisibilityView
